<template lang="pug">
div
  .pa-1.d-flex.justify-space-between.align-start(v-if="recur")
    //- Content
    div
      div.text-sm.neutral700--text {{ recur.servicesName }}
      .d-flex.align-center.text-xxs.neutral500--text
        template(v-if="recur.start && recur.until")
          .mr-1 {{ formatDate(recur.start) }},
          .mr-1 {{ formatDuration(recur.start, recur.until) }},
        template(v-else)
          .text-xxs.neutral300.round-sm.px-2.neutral500--text.mr-2 Set later
        v-avatar.mr-1(color="neutral300" size="11" rounded="circle")
          v-img(v-if="recur.provider.profile_image" width="11" height="11" :src="recur.provider.profile_image.file")
          v-icon(v-else size="11") $yzi-user-03
        div {{ recur.provider.name }}
    //- Action
    v-btn.rounded-lg.button-sm(v-if="recur.status === 'cancelled'" disabled outlined)
      .text-sm Cancelled
    v-btn.rounded-lg.button-sm(v-else outlined :loading="isLoading" @click="onClickActionButton")
      .text-sm {{ isPending ? 'Set date' : 'View' }}
</template>

<script>
import { DateTime, Interval } from 'luxon'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    parentRecur: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      recur: null,
      isLoading: false
    }
  },
  mounted () {
    this.recur = this.sanitizeRecur(this.parentRecur)
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    isPending () {
      return this.recur?.status === 'pending'
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    sanitizeRecur (obj) {
      const newObj = {...obj}
      // Service name
      newObj.servicesName = obj.services.map(service => service.name).join(', ')
      
      return newObj
    },
    formatDate (datetime) {
      if (!datetime) return null

      return DateTime.fromISO(datetime).toFormat('dd MMM yyyy')
    },
    formatDuration (start, until) {
      if (!start || !until) return null

      const fromTime = DateTime.fromISO(start)
      const untilTime = DateTime.fromISO(until)
      
      const interval = Interval.fromDateTimes(fromTime, untilTime)
      const duration = interval.toDuration(['hours', 'minutes']).toObject()

      let result = ''

      if (duration.hours) result += `${duration.hours} hr`
      if (duration.minutes) result += ` ${duration.minutes} min`

      return result.trim()
    },
    async fetchAppointment (selectedId) {
      try {
        const { data } = await this.$axios.get(`/clinics/${this.company.slug}/appointments/${selectedId}`)
        return data
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        return null
      }
    },
    async onClickActionButton () {
      this.isLoading = true

      if (this.isPending) {
        this.$emit('setDate', this.recur)
      } else {
        this.$emit('view')
      }

      this.isLoading = false
    }
  }
}
</script>

<style scoped>
</style>